/**
 * 统一错误提取工具
 *
 * 在各 Store 的 catch 块中调用此函数，将 AxiosError / ApiError / 普通 Error
 * 统一提取为用户友好的错误消息。
 *
 * 用法：
 *   try { ... }
 *   catch (e) { error.value = extractErrorMessage(e, '默认消息') }
 */
import { classifyError } from '@/utils/httpClient'

/**
 * 从各种错误对象中提取用户友好的消息。
 *
 * @param e - 捕获到的错误对象
 * @param fallback - 兜底消息
 * @returns 分类后的错误消息（网络异常时会附加提示）
 */
export function extractErrorMessage(e: unknown, fallback: string): string {
  const classified = classifyError(e)

  // 网络/超时/服务器错误：附加友好提示
  if (classified.shouldShowGlobalAlert) {
    return classified.userMessage
  }

  // 业务 4xx：优先用分类结果中的消息 —— AxiosError 的 e.message 是英文原始信息
  // （如 "Request failed with status code 429"），分类时已提取后端返回的 message
  if (classified.status !== undefined && classified.status >= 400 && classified.status < 500) {
    return classified.userMessage || fallback
  }

  // 其他错误：直接使用原始消息
  if (e instanceof Error) {
    return e.message || fallback
  }

  return fallback
}
